import styled from "styled-components";
import { Colors } from "../../../../constants/Colors";

export const WashingsContainer = styled.div`
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    padding: 1rem;
    max-height: 900px;
    overflow-y: scroll;
    p {
        color: ${Colors.primary[100]}; 
        font-weight: 200;
        font-size: 2rem;
        margin: 0;
    }
`;

export const NoWashings = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

export const NoStation = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
`;
